export default __webpack_public_path__ + "static/TypeMates-SombraBold-ebf2b05c8b828668dc352c12a655fd83.otf";